import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import styles from '../css/index.module.scss';
import DotsIcon from '../../../assets/formIcons/dots.svg';
import useComponentVisible from '../../../helpers/hooks/useComponentVisible';
import BlockIcon from '../../../assets/formIcons/block.svg';
import EditIcon from '../../../assets/formIcons/edit.svg';
import TableCell from '../../../components/TableCell';
import TableInput from '../../../components/TableInput';

function CategoryListItem({
  item,
  textToShow,
  selected,
  clickable,
  onItemClick,
  onRenameClick,
  onDeleteClick,
  sort,
  handleSort,
  translationsEntityType,
}) {
  const navigate = useNavigate();
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const handlePopUpClick = (fn) => (...args) => {
    setIsComponentVisible(false);
    fn(...args);
  };

  const onTranslationsClick = () => {
    setIsComponentVisible(false);
    if (!translationsEntityType || !item?._id) return;
    navigate(`/translations?entity_type=${translationsEntityType}&entity_id=${item._id}`);
  };

  return (
    <div className={classNames(styles.listItem, { [styles.listItemSelected]: selected, [styles.listItemClickable]: clickable })} onClick={onItemClick}>
      <div className={styles.listItemLeft}>
        <div className={styles.listItemSort}>
          <TableInput
            value={sort}
            onChange={handleSort}
            type="number"
            placeholder="XXX"
            onClick={(ev) => {
              ev.stopPropagation();
            }}
          />
        </div>
        <p className={styles.listItemText}>{textToShow}</p>
      </div>
      <TableCell
        isIcon
        onClick={(ev) => {
          ev.stopPropagation();
          setIsComponentVisible(true);
        }}
      >
        <img src={DotsIcon} alt=":" />
      </TableCell>

      <div
        ref={ref}
        className={`table_popup ${isComponentVisible && 'visible'}`}
        onClick={(ev) => ev.stopPropagation()}
      >
        <div className="table_popup_item" onClick={handlePopUpClick(onRenameClick)}>
          <img src={EditIcon} alt="" />
          <p>Переименовать</p>
        </div>
        {translationsEntityType ? (
          <div className="table_popup_item" onClick={onTranslationsClick}>
            <img src={EditIcon} alt="" />
            <p>Переводы</p>
          </div>
        ) : null}
        <div className="table_popup_item" onClick={handlePopUpClick(onDeleteClick)}>
          <img src={BlockIcon} alt="" />
          <p>Удалить</p>
        </div>
      </div>
    </div>
  );
}

export default CategoryListItem;
